//Node imports
import { IEvent, IObject, dispatcher, toInt } from "@quest/base-core";
import { FreeGameReelPanelControllerBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-leopard/dist"
import { SlotEventConstants, SymbolBase } from "@quest/slot-core";
import { Model as platformModel } from "@quest/platform-murka/dist";

//Class imports
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class FreeGameReelPanelControllerGame extends FreeGameReelPanelControllerBehavior {

  /**
     * subscribe all events
     */
  protected subscribeEvents() {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UDPATE_NEW_FG_REELSET, this.updateReelsets, this);
  }

  /**
   * unsubscribe all events 
   */
  protected unsubscribeEvents() {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.UDPATE_NEW_FG_REELSET, this.updateReelsets);
  }
  /**
       * This method is use to update reelsets
       */
  private updateReelsets() {
    this.reelView.getModel().setReelsets([(ingenuity.parserModel as GameParserModel).getFreeSpinReel()]);
  }

  /**
  * to unfade symbol  on reels after anticipation ends
  */
  private unFadeSymbolAfterAnticipation(): void {
    let numOfReel: number = this.reelView.getModel().numReels;
    let reelGrid: any[] = this.model.getReelGrid();
    for (let i: number = 0; i < numOfReel; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        this.reelView.getSymbolByPos(i, j).getStatic().tint = gameConstants.UNFADED_SYMBOL;
        if (reelGrid[i][j] === gameConstants.POT_SYMBOL) {
          this.unFadePotLandingSpine(this.reelView.getSymbolByPos(i, j));
        }
      }
    }
  }

  /**
   *  Method unFadePotLandingSpine to unfade Pot symbol landing anim
   * */
  private unFadePotLandingSpine(symbol: SymbolBase): void {
    const container = symbol.getAnimation().children;
    const tintValue = gameConstants.UNFADED_SYMBOL;
    container.forEach((value: any) => {
      value.parent.tint = tintValue;
    }, this);
  }

  /**
 *  To show faded symbol except for bonus symbols on reels during anticipation
 * */
  private fadeSymbolOnAnticipation(reel: number): void {
    let numOfReel: number = reel;
    let reelGrid: any[] = this.model.getReelGrid();
    for (let i: number = 0; i <= numOfReel; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === gameConstants.POT_SYMBOL) {
          this.fadePotLandingSpine(this.reelView.getSymbolByPos(i, j));
        }
        if (reelGrid[i][j] !== gameConstants.FREESPIN_SYMBOL_GAME) {
          this.reelView.getSymbolByPos(i, j).getStatic().tint = gameConstants.FADED_SYMBOL;
        }
      }
    }
  }

  /**
 *  Method fadePotLandingSpine to fade Pot symbol landing anim
 * */
  private fadePotLandingSpine(symbol: SymbolBase): void {
    const container = symbol.getAnimation().children;
    const tintValue = gameConstants.FADED_SYMBOL;
    container.forEach((value: any) => {
      value.parent.tint = tintValue;
    }, this);
  }


  /**
   *  override to check for anticipation
   * */
  protected checkForAnticipation(symbolObj: any, listLength: number): void {
    let i: number, j: number, k: number, n: number;
    let symbolCount: number = 0;
    let anticipation: number[] = [];
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
      this.reelView.getModel().anticipationSpin[i] = 0;
      if (symbolObj.aniticipationRunOnReel[i] != 0) {
        if (symbolCount >= symbolObj.symbolCount && symbolObj.aniticipationRunOnReel[i] !== -1) {
          if (ingenuity.configData.anticipationRunAfterFeature) {
            anticipation[i] = 1;
          }
          else {
            if (symbolCount >= symbolObj.symbolCount + 1) {
              anticipation[i] = 0;
            }
            else {
              anticipation[i] = 1;
            }
          }
        }
      }
      for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
        if (this.model.getReelGrid()[i][j] === symbolObj.symbolId && symbolObj.aniticipationRunOnReel[i] !== -1) {
          symbolCount++;
        }
      }
    }
    this.anticipationList.push(anticipation);
    if (this.anticipationList.length === listLength) {
      for (k = 0; k < this.anticipationList.length; k++) {
        for (n = 0; n < this.anticipationList[k].length; n++) {
          if (this.anticipationList[k][n] === 1) {
            this.reelView.getModel().anticipationSpin[n] = 1;
          }
        }
      }
    }
    this.checkForlandingAnim(symbolObj, listLength);
  }

  //override to check landing animation for pot symbol
  protected checkForlandingAnim(symbolObj: IObject, listLength: number) {
    let i, j;
    let symbolCount = 0;
    let symbolFound = false;
    const symbolNeeded = symbolCount + 1;
    const NumReel = this.reelView.getModel().numReels;
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
      for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
        if (this.model.getReelGrid()[i][j] === symbolObj.symbolId || this.model.getReelGrid()[i][j] === gameConstants.POT_SYMBOL) {
          symbolFound = true;
          break;
        }
      }
      if (symbolFound) {
        symbolCount++;
        if (symbolFound && i < (NumReel - (symbolNeeded - symbolCount))) {
          this.reelView.getModel().landingOnReel[i] = 1;
        }
        symbolFound = false;
      }
    }
  }

  /**
* When all Reels started to stop and about to bounce but not stopped completely
* @listens `SlotEventConstants.FG_REEL_STOPPING`
*/
  protected onReelStopping(evt: IEvent): void {
    const reelNo: number = toInt(evt.toString());
    console.log("controller reel stoping event ", evt.data, evt);
    this.view.clearAnticipation();
    const value: IObject = (ingenuity.parserModel as platformModel).getLandingSoundOnReel()[0][reelNo];
    if (value === undefined && !ingenuity.configData.isPlayAnticipationSound && !this.model.getIsTurboModeOn()) {
      ingenuity.soundManager.playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
    }
    if (this.model.getIsTurboModeOn() && (toInt(evt.toString()) === 0)) {
      ingenuity.soundManager.playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
    }
    if (ingenuity.configData.isPlayAnticipationSound) {
      // Play anticipation reel stop sound
      (ingenuity.soundManager as any).playSound(SoundConstantGame.ANTICIPATION_REEL_STOP, 1, false, gameConstants.SOUND_LIST_PRELOAD);
    }

    if (this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] &&
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] === 1) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_ANTICIPATION, toInt(evt.toString()) + 1);
      this.fadeSymbolOnAnticipation(toInt(evt.toString()));
      ingenuity.configData.currentAnticipation = toInt(evt.toString()) + 1;
    }
    if (this.reelView.getModel().landingOnReel[reelNo] && this.reelView.getModel().landingOnReel[reelNo] === 1) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_LANDINGANIMATION, [this.model.getReelGrid(), this.reelView, reelNo]);
    }
    for (let m: number = 0; m < (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel().length; m++) {
      const value: IObject = (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()[m][reelNo];
      value && dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_LANDING_SOUNDS_FG, [value, (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()]);
    }
    // to unfade all reels on last reel stopping
    if (toInt(evt.toString()) === 4) {
      this.unFadeSymbolAfterAnticipation();
    }
  }

  /**
  * Method onReelStopped to stop anticipation sound
  */
  protected onReelStopped(evt?: IEvent) {
    super.onReelStopped(evt);
    const reelNo: number = toInt(evt.toString());
    if (reelNo === 4) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.ANTICIPATION_SOUND, gameConstants.SOUND_LIST_PRELOAD);
    }
  }
}

